module.exports = __webpack_public_path__ + "static/laundromatslider-01-min-7ed85ddca1f8f3578654e6ddb3a1480c.jpg";